import { UsersError } from '@/lib/Errors';
import _axios from '@/plugins/axios';
export default {
  // API's FOR PATIENT MAPPING
  async getMappedEcpUsersForHospital (id) {
    const response = await _axios.get('ecp/getmappedecpresidentsforhospital', {
      headers: { hospitalId: id },
    });
    if (response.data.resFlag) {
      const userJson = response.data.data;
      return userJson;
    } else {
      throw new UsersError('Invalid id');
    }
  },
  async deleteMappedUser (id) {
    const response = await _axios.delete(`ecp/${id}`);
    if (response.data.resFlag) {
      const userJson = response.data.data;
      return userJson;
    } else {
      throw new UsersError('Invalid id');
    }
  },
  async mapUser (body) {
    const response = await _axios.post('ecp/addmappedecpuser', body);
    if (response.data.resFlag) {
      const userJson = response.data;
      return userJson;
    } else {
      throw new UsersError('Password could not be changed!');
    }
  },

  // API's MEDICAL STAFF MAPPING

  async getMappedEcpMedicalStaffForHospital (id) {
    const response = await _axios.get(
      'ecp/getmappedecpmedicalstaffforhospital',
      { headers: { hospitalId: id } },
    );
    if (response.data.resFlag) {
      const userJson = response.data.data;
      return userJson;
    } else {
      throw new UsersError('Invalid id');
    }
  },
  // Organization
  async getMappedEcpOrganization () {
    const response = await _axios.get('ecp/getmappedecporganization');
    if (response.data.resFlag) {
      const userJson = response.data.data;
      return userJson;
    } else {
      throw new UsersError('Invalid id');
    }
  },
  async addEcpMapForCompany (body) {
    const response = await _axios.post('ecp/addecpmapforcompany', body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new UsersError(response.data.msg);
  },
  async editEcpMapForCompany (body) {
    const response = await _axios.put(
      `ecp/updateecpmapforcompany/${body.id}`,
      body,
    );
    if (response.data.resFlag) {
      return response.data;
    }
    throw new UsersError(response.data.msg);
  },
  async deleteMappedEcpOrganization (id) {
    const response = await _axios.delete(`ecp/deleteecpmapforcompany/${id}`);
    if (response.data.resFlag) {
      const userJson = response.data.data;
      return userJson;
    } else {
      throw new UsersError('Invalid id');
    }
  },

  // Location
  async getMappedEcpLocation () {
    const response = await _axios.get('ecp/getmappedecplocation');
    if (response.data.resFlag) {
      const userJson = response.data.data;
      return userJson;
    } else {
      throw new UsersError('Invalid id');
    }
  },
  async getNotMappedEcpLocation () {
    const response = await _axios.get('ecp/getnotmappedecplocation');
    if (response.data.resFlag) {
      const userJson = response.data.data;
      return userJson;
    } else {
      throw new UsersError('Invalid id');
    }
  },
  async addEcpMapForLocation (body) {
    const response = await _axios.post('ecp/addecpmapforlocation', body);
    if (response.data.resFlag) {
      return response.data;
    }
    throw new UsersError(response.data.msg);
  },
  async updateEcpMapForLocation (body) {
    const response = await _axios.put(
      `ecp/updateecpmapforlocation/${body.id}`,
      body,
    );
    if (response.data.resFlag) {
      return response.data;
    }
    throw new UsersError(response.data.msg);
  },
  async deleteEcpMapForLocation (id) {
    const response = await _axios.delete(`ecp/deleteecpmapforlocation/${id}`);
    if (response.data.resFlag) {
      const userJson = response.data.data;
      return userJson;
    } else {
      throw new UsersError('Invalid id');
    }
  },

  // PCC
  async getMappedPccLocation () {
    const response = await _axios.get('pcc/getmappedpcclocations');
    if (response.data.resFlag) {
      const userJson = response.data.data;
      return userJson;
    } else {
      throw new UsersError('Invalid id');
    }
  },
  async updatePccMapForLocation (body) {
    const response = await _axios.put(
      `pcc/pcclocationupdatemapping/${body.id}`,
      body,
    );
    if (response.data.resFlag) {
      return response.data;
    }
    throw new UsersError(response.data.msg);
  },

  async getNotMappedPccLocation () {
    const response = await _axios.get('ecp/getmappedpcclocations');
    if (response.data.resFlag) {
      const userJson = response.data.data;
      return userJson;
    } else {
      throw new UsersError('Invalid id');
    }
  },
};
